/*  MUI  */
import { Box } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { Tab } from '../../Components/Tab';

/*  Components  */
import { IconForTab } from './SidebarIcons';

/**
 * Component that renders the global menu items in the sidebar.
 * Displays a single menu item for global administration with a wrench icon.
 * Only accessible to users with 'partner' permission.
 * @returns JSX element containing the global menu items
 */
export const SidebarGlobalMenuItems = () => {
    const { t } = useTranslation();
    const { clientId, partnerId } = useParams();
    const baseRoute = '/globaladmin';

    return (
        <Box
            data-testid="renderGlobalMenuItem"
            data-trackid="renderGlobalMenuItem"
            mb="4px"
            style={{ display: 'flex', flexDirection: 'column' }}
        >
            <Tab
                icon={<IconForTab src="BuildWrench" />}
                id="global_administration"
                name={t('Common.global_administration')}
                permission="global_system_admin"
                route={baseRoute}
                subTabs={
                    <>
                        {partnerId && (
                            <Tab
                                id="global_administration_partner_view"
                                name={t('GlobalAdmin.Sidebar.PartnerDetails')}
                                permission="global_system_admin"
                                route={`${baseRoute}/tenant/${partnerId}`}
                                subTab
                            />
                        )}
                        {clientId && (
                            <Tab
                                id="global_administration_client_view"
                                name={t('GlobalAdmin.Sidebar.ClientDetails')}
                                permission="global_system_admin"
                                route={`${baseRoute}/tenant/${clientId}`}
                                subTab
                            />
                        )}
                    </>
                }
                variant="sidebarMainTab"
            />
        </Box>
    );
};
